import {StrictMode} from 'react'; import {createRoot} from 'react-dom/client'; import {AuthenticatedApp} from './AuthenticatedApp'; import './styles.css'; import './functional.css';
createRoot(document.getElementById('root')!).render(<StrictMode><AuthenticatedApp/></StrictMode>);
